module.exports = __webpack_public_path__ + "static/media/work-description.0e52d760.svg";